import DataTable from "./DataTable";

export type { IColumn } from "./DataTable";
export default DataTable